import { render, staticRenderFns } from "./GroupSessionCanceledNotification.vue?vue&type=template&id=b79f0516&scoped=true&"
import script from "./GroupSessionCanceledNotification.vue?vue&type=script&lang=js&"
export * from "./GroupSessionCanceledNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b79f0516",
  null
  
)

export default component.exports